// Contexto para anmazenar dados do ID do AutoComplete escolhido

import React, { createContext, useState } from "react";

export const PlanoSaudeIdContext = createContext()
export const PlanoSaudeNomeContext = createContext()

export const PlanoSaudeContextProvider = ({ children }) => {
    const [planoSaudeIdContext, setPlanoSaudeIdContext] = useState('')
    const [planoSaudeNomeContext, setPlanoSaudeNomeContext] = useState('')

    return (
        <PlanoSaudeIdContext.Provider value={{ planoSaudeIdContext, setPlanoSaudeIdContext }}>
            <PlanoSaudeNomeContext.Provider value={{ planoSaudeNomeContext, setPlanoSaudeNomeContext }}>
                {children}
            </PlanoSaudeNomeContext.Provider>
        </PlanoSaudeIdContext.Provider>
    )
}